'use client';
/**
 * region_home1 (2026-10-18 · region-a) — 홈 히어로의 «지역 의존 칸» 섬 3개. 서버 HTML·첫 수화 렌더 = 전국(props 그대로 · 같은 마크업).
 *   지역이 정해지면(useHomeRegion ready) /api/home/region 응답의 scopeLabel · stats · hero 로 갈아 그린다.
 *
 *   <HomeScopeEyebrow national="전국 · 10월 18일 기준" today="2026-10-18" />   머리줄(텍스트만 · <p> 는 Hero 가 낸다)
 *   <HomeRegionStats stats={전국 4칸} />                                         통계 <dl class="ds2-stats">
 *   <HomeRegionHero national={[전국 HeroFeature…]} />                            대표 현장 캐러셀(region_home1b HeroFeatureCarousel · 1장이면 단일 카드)
 *
 * ⛔ 지역 응답에 칸이 없으면(옛 캐시 · 실패) 전국 값을 «지역 화면에» 남기지 않는다 — 칸째 생략(다른 시도 현장 0).
 */
import React from 'react'; // vitest(클래식 JSX) 렌더 검증용
import { HeroStats, type HeroStat, type HeroFeature } from '@/components/ds2/Hero';
import { HeroFeatureCarousel } from './carousel/HomeHeroCarousel';
import { heroFeatureOf, homeScopeLabel } from '@/lib/home/region-scope-pure';
import { useHomeRegion } from './HomeRegionFilter';

export function HomeScopeEyebrow({ national, today }: { national: string; today: string }) {
  const st = useHomeRegion();
  if (st.status !== 'ready') return <>{national}</>;
  return <>{st.data.scopeLabel || homeScopeLabel(st.data.label, today)}</>;
}

export function HomeRegionStats({ stats }: { stats: HeroStat[] }) {
  const st = useHomeRegion();
  if (st.status !== 'ready') return <HeroStats stats={stats} />;
  return <HeroStats stats={st.data.stats ?? null} />;
}

/** 지역 히어로 카드 목록(HeroFeature) — ready 면 지역(폴백 사슬 반영), 아니면 전국. region-b 캐러셀이 같은 훅을 쓴다. */
export function useHomeHeroFeatures(national: readonly HeroFeature[]): { features: HeroFeature[]; region: string | null } {
  const st = useHomeRegion();
  if (st.status !== 'ready') return { features: [...national], region: null };
  return { features: (st.data.hero ?? []).map(heroFeatureOf), region: st.data.code };
}

/**
 * 대표 현장 — region_home1b 캐러셀(상위 5 · 1장이면 종전 단일 카드 마크업 그대로 · 래퍼 0).
 *   서버·첫 수화 = 전국 배열(national) · 지역 확정 뒤 = payload.hero(폴백 사슬 반영). 지역 응답에 hero 가 없으면 빈 배열(다른 시도 카드 0).
 *   첫 화면 가림: 캐러셀 루트 data-kd-hr-dep · 단일 카드는 [data-cl-section="search"] .ds2-feat 규칙(home-region.css)이 덮는다.
 */
export function HomeRegionHero({ national }: { national: HeroFeature[] }) {
  const { features } = useHomeHeroFeatures(national);
  return <HeroFeatureCarousel features={features} />;
}
